module.exports = __webpack_public_path__ + "static/media/1962-63.3efcc452.pdf";